import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor
} from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { signOut } from 'aws-amplify/auth';

import { AuthenticationService } from '../services/auth.service';
import { ToastService } from 'src/app/shared/toast.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    private logoutInProgress = false;

    constructor(
        private authenticationService: AuthenticationService,
        private toastService: ToastService,
        private router: Router
    ) {}

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError(err => {
                if (err.status === 401 || err.status === 403) {
                    if (environment.defaultauth === 'cognito') {
                        void this.logoutFromCognito();
                    } else {
                        this.authenticationService.logout();
                        location.reload();
                    }

                    return throwError(() => err);
                }

                const errorMessage =
                    err?.error?.title ||
                    err?.error?.message ||
                    'Request failed';

                this.toastService.show(errorMessage, {
                    classname: 'bg-danger text-white',
                    delay: 5000,
                });

                return throwError(() => err);
            })
        );
    }

    private async logoutFromCognito(): Promise<void> {
        if (this.logoutInProgress) {
            return;
        }

        this.logoutInProgress = true;

        try {
            await signOut();

            await this.router.navigate(['/']);
        } catch (error) {
            console.error('Cognito logout failed', error);
            await this.router.navigate(['/']);
        }
    }
}